/**
 * Kill switch for the preview-phase speed-ups: a resize pool sized to the machine
 * (src/lib/image/resizeImage.ts), per-file completions on the throttled re-render, and more uploads in
 * flight over the HTTP/2 upload Worker (src/hooks/useUploadManager.tsx). On by default;
 * `localStorage ph_preview_speed=0` restores the previous behaviour in this browser (the resize pool
 * picks it up on the next page load, the upload manager on the next batch).
 */
export const previewSpeedOn = (): boolean => {
  try {
    return globalThis.localStorage?.getItem("ph_preview_speed") !== "0";
  } catch {
    return true; // localStorage unavailable (sandboxed / private mode) — keep the default
  }
};
